import { useEffect, useState, type JSX } from 'react';

export interface CommitInputProps {
  id?: string;
  value: string;
  label: string;
  onCommit(value: string): void;
  type?: 'text' | 'password' | 'url';
  placeholder?: string;
  invalid?: boolean;
  disabled?: boolean;
}

/**
 * Text input that writes to the document on blur or Enter rather than on every
 * keystroke, so typing a URL is one undo step and never stores half a value.
 */
export function CommitInput({ id, value, label, onCommit, type = 'text', placeholder, invalid, disabled }: CommitInputProps): JSX.Element {
  const [draft, setDraft] = useState(value);
  useEffect(() => setDraft(value), [value]);
  const commit = (): void => {
    if (draft !== value) onCommit(draft);
  };
  return (
    <input
      id={id}
      className={invalid ? 'ui-input invalid' : 'ui-input'}
      style={{ width: '100%' }}
      type={type}
      aria-label={label}
      aria-invalid={invalid || undefined}
      placeholder={placeholder}
      autoComplete="off"
      spellCheck={false}
      disabled={disabled}
      value={draft}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') commit();
      }}
    />
  );
}
